import React from 'react';

/**
 * ShipAssure branded logo mark — a stylised package/box with a checkmark shield.
 * Renders as an inline SVG so it works without any image assets.
 */
const ShipAssureLogo = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="ShipAssure logo"
  >
    {/* Box body */}
    <rect x="4" y="14" width="32" height="22" rx="3" fill="#1d4ed8" />
    {/* Box lid */}
    <path d="M2 14 L20 7 L38 14 L20 21 Z" fill="#2563eb" />
    {/* Lid centre stripe */}
    <line x1="20" y1="7" x2="20" y2="21" stroke="#93c5fd" strokeWidth="1.5" />
    {/* Horizontal ribbon on body */}
    <rect x="4" y="22" width="32" height="4" rx="1" fill="#1e40af" />
    {/* Vertical ribbon */}
    <rect x="17.5" y="14" width="5" height="22" rx="1" fill="#1e40af" />
    {/* Shield badge (bottom-right) */}
    <circle cx="30" cy="30" r="7" fill="#16a34a" />
    {/* Checkmark */}
    <polyline
      points="26.5,30 29,32.5 33.5,27.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default ShipAssureLogo;